/* eslint-disable react-hooks/exhaustive-deps */
import {
	IonChip,
	IonContent,
	IonIcon,
	IonItem,
	IonLabel,
	IonList,
	IonPage,
	IonSegment,
	IonSegmentButton,
} from "@ionic/react";
import {useCallback, useEffect, useState} from "react";
import {useLocation} from "react-router";
import {useRecoilState, useSetRecoilState} from "recoil";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import {HeaderBase, SkinInfoItem} from "../../components";
import {useApi} from "../../hooks/api";
import {
	categoryListState,
	infoCategoryIdState,
	infoFilterIdState,
	infoListState,
	infoPageIndexState,
	searchPageTypeState,
} from "../../store/atoms";
import {BannerType, CategoryDto, ListData, SkinInfo} from "../../store/types";
import {bannerSliderOption} from "../configs";

const SkinInfoPage: React.FC = () => {
	const location: any = useLocation();
	const [infoFilterCategory, setInfoFilterCategory] = useState<any>(location.state?.infoFilterCategory);

	const pageSize = 10;
	const {processApi} = useApi();

	const [pageIndex, setPageIndex] = useRecoilState(infoPageIndexState);
	const [categoryList, setCategoryList] = useRecoilState(categoryListState);
	const [categoryId, setCategoryId] = useRecoilState(infoCategoryIdState);
	const [filterId, setFilterId] = useRecoilState(infoFilterIdState);

	const [isLoaded, setIsLoaded] = useState<boolean>(false);
	const [categoryExpanded, setCategoryExpanded] = useState<boolean>(false);

	const [list, setList] = useRecoilState(infoListState);
	const setSearchPageType = useSetRecoilState(searchPageTypeState);

	const [adBannerList, setAdBannerList] = useState<BannerType>();
	const [bannerAdType, setBannerAdType] = useState<number>(1);
	const [bannerSectionType, setBannerSectionType] = useState<number>(6);

	const paginationOption = {
		customPaging: function (slider: any) {
			return (
				<span>
					{slider + 1}/{adBannerList?.totalCount}
				</span>
			);
		},
	};

	const fetchCategories = useCallback(async () => {
		let data: any[] | null; // :CategoryDto[] = []
		try {
			data = await processApi<CategoryDto[]>("category");
		} catch (error) {
			data = null;
		}

		let categories = [{key: "-1", name: "전체"}];
		if (data !== null) {
			categories.push(...data);
		}

		setCategoryList(categories);
		setCategoryId(categories[0].key);
	}, []);

	const fetchList = useCallback(
		async (category, pageIndex: number) => {
			let params: any = {pageIndex: pageIndex, pageSize: pageSize};

			if (category !== "-1" && filterId && filterId !== "-1") {
				params["category"] = filterId;
			} else if (category !== "-1" && !filterId) {
				params["category"] = category;
			}
			const data = await processApi<any>("info", params);

			setList((prev: ListData<any>) => {
				if (pageIndex === 0) return data;
				else return {total: data.total, list: [...prev.list, ...data.list]};
			});

			setPageIndex(prev => (prev = pageIndex + 1));
		},
		[filterId, categoryId],
	);

	const getdBannerList = async () => {
		let params = {
			adType: bannerAdType,
			sectionType: bannerSectionType,
		};

		try {
			const data = await processApi<any>("ad", params);
			setAdBannerList(data);
		} catch (e) {
			console.log(e);
		}
	};

	const moveScroll = (key: string) => {
		const offsetLeft = document.getElementById(`segmentButton${key}`)?.offsetLeft ?? 0;
		const clientWidth = document.getElementById(`segmentButton${key}`)?.clientWidth ?? 0;
		let innerWidth: number = window.innerWidth;
		if (innerWidth > 480) innerWidth = 480; // PC max-width 480px
		document.getElementById("segment")?.scroll(offsetLeft - innerWidth / 2 + clientWidth / 2, 0);
	};

	function scrollLeft() {
		document.getElementById("segment")!.scrollLeft -= 100;
	}

	function scrollRight() {
		document.getElementById("segment")!.scrollLeft += 100;
	}

	const handleClass = (key: any) => {
		if (filterId && key === filterId) {
			return "selected";
		} else if (!filterId && !infoFilterCategory && key === categoryId) {
			return "selected";
		} else {
			return "";
		}
	};

	const handleClassSubMenu = (key: any) => {
		if (filterId && key === filterId) {
			return "active";
		} else if (!filterId && !infoFilterCategory && key === categoryId) {
			return "active";
		} else {
			return "";
		}
	};

	useEffect(() => {
		fetchCategories();
		setSearchPageType("info");
		getdBannerList();
	}, []);

	useEffect(() => {
		moveScroll(filterId ? filterId : categoryId);
	});

	useEffect(() => {
		setIsLoaded(true);
	}, []);

	useEffect(() => {
		if (infoFilterCategory) {
			setFilterId(infoFilterCategory);
		} else {
			setFilterId(null);
		}
	}, []);

	useEffect(() => {
		setTimeout(() => {
			if (!infoFilterCategory && !filterId) {
				fetchList(categoryId, 0);
			} else {
				fetchList(filterId, 0);
			}
		}, 50);
	}, [filterId, categoryId]);

	return (
		<IonPage className="pg-skin-info">
			<HeaderBase title="쏙쏙 피부 정보" enableSearch={true} />
			<div className="menu-wrap">
				{/* 피부증상 메뉴 */}
				<IonSegment
					id="segment"
					className="menu"
					slot="start"
					scrollable
					value={filterId ? filterId : categoryId}
					mode="md"
					onIonChange={event => {
						const id = event.detail.value ?? "";
						setCategoryId(id);
						if (infoFilterCategory) {
							setFilterId(id);
						}
					}}
				>
					{categoryList.map((x, index) => (
						<IonSegmentButton
							id={`segmentButton${x.key}`}
							key={`category_button_${x.key}`}
							value={x.key}
							mode="md"
							className={filterId ? handleClassSubMenu(x.key) : handleClass(x.key)}
							onClick={() => {
								setCategoryExpanded(false);
								moveScroll(filterId ? filterId : x.key);
							}}
						>
							{x.name}
						</IonSegmentButton>
					))}
					<IonSegmentButton>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</IonSegmentButton>
				</IonSegment>

				<div className="menu-all">
					<img
						slot="end"
						src={categoryExpanded ? "assets/icon/icons_expand_less.png" : "assets/icon/icons_expand_more.png"}
						alt="more"
						className="icon"
						onClick={() => setCategoryExpanded(prev => !prev)}
					/>
				</div>

				<div className="menu-before">
					<img
						slot="end"
						src="assets/icon/icons_navigate_before.png"
						alt="prev"
						className="icon"
						onClick={() => scrollLeft()}
					/>
				</div>

				<div className="menu-next">
					<img
						slot="end"
						src="assets/icon/icons_navigate_next.png"
						alt="next"
						className="icon"
						onClick={() => scrollRight()}
					/>
				</div>

				{categoryExpanded ? (
					<IonSegment slot="start" className="wrap menu-contents" mode="md">
						{categoryList.map((category, index) => (
							<IonChip
								key={`category_segment_${category.key}`}
								outline
								onClick={() => {
									setCategoryExpanded(false);
									setCategoryId(category.key);
									if (infoFilterCategory) {
										setFilterId(category.key);
									}
									moveScroll(category.key);
								}}
								className={handleClass(category.key)}
							>
								<IonLabel color="primary">{category.name}</IonLabel>
							</IonChip>
						))}
					</IonSegment>
				) : (
					<></>
				)}
			</div>
			<IonContent fullscreen>
				<div className="content-inner">
					{adBannerList && (
						<Slider {...bannerSliderOption} {...paginationOption} className="banner-slider">
							{adBannerList?.detailList?.map((item, index) => (
								<div key={index}>
									<img
										src={item.fileUrl}
										onClick={() => (item.targetUrl ? window.open(item.targetUrl) : undefined)}
										alt="ad"
									/>
								</div>
							))}
						</Slider>
					)}
					{(list?.list?.length ?? 0) === 0 ? (
						<div className="no-result">
							{filterId && filterId !== "-1" ? filterId : ""} 조회 결과가 없습니다.
						</div>
					) : (
						<></>
					)}
					<IonList className="info-contents">
						{list?.list?.map((info: SkinInfo, index) => {
							return <SkinInfoItem info={info} key={`info_${info.id}`} />;
						})}
						{(list?.list?.length ?? 0) > 0 && (list?.total ?? 0) > pageIndex * pageSize ? (
							<IonItem className="btn-more" onClick={() => fetchList(categoryId, pageIndex)}>
								<p>
									더보기<em></em>
								</p>
							</IonItem>
						) : (
							<></>
						)}
					</IonList>
				</div>
			</IonContent>
		</IonPage>
	);
};

export default SkinInfoPage;
